import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/compras/abonos';
import Abonos from './AbonosList';


const ms2p = (state) => {
  return {
    ...state.abono_cxp,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Abonos);
